import {dataTestId} from '@hconnect/uikit'
import {HPButton} from '@hconnect/uikit/src/lib2'
import {Add} from '@mui/icons-material'
import {Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {PastFutureTimeframeSelect} from '../../../shared/components/formComponents/PastFutureTimeframeSelect'
import {useSelectedMaterialOrder} from '../../../shared/components/providers/SelectedMaterialOrderProvider'
import {useSelectedTimeframe} from '../../../shared/components/providers/SelectedTimeframeProvider'
import {usePermission} from '../../../shared/hooks/permissions/usePermission'
import {usePlanRange} from '../../../shared/hooks/usePlanRange'
import {usePlantConfig} from '../../../shared/hooks/usePlantConfigData'

const TIMEFRAME_DURATIONS_DAYS = [1, 3, 5, 9, 15]

type MaterialOrdersTitleActionsProps = {
  canAddMaterialOrder: boolean
}

export const MaterialOrdersTitleActions: React.FC<MaterialOrdersTitleActionsProps> = ({
  canAddMaterialOrder
}) => {
  const {t} = useTranslation()
  const {created_at: createdAt, timezone_id: timezoneId} = usePlantConfig()
  const {selectedTimeframe, setSelectedTimeframe} = useSelectedTimeframe()
  if (!selectedTimeframe) {
    throw new Error('BUG: Selected timeframe is not defined')
  }
  const {setSelectedMaterialOrder} = useSelectedMaterialOrder()
  const [startOfPlan] = usePlanRange({createdAt, timezoneId})

  const canChangeMaterialOrders = usePermission('CHANGE_MATERIAL_ORDERS')

  return (
    <Stack direction="row" spacing={1.5}>
      <PastFutureTimeframeSelect
        pastDurationDays={TIMEFRAME_DURATIONS_DAYS}
        futureDurationDays={TIMEFRAME_DURATIONS_DAYS}
        startOfToday={startOfPlan.clone().startOf('day')}
        timeframe={selectedTimeframe}
        onTimeframeChange={setSelectedTimeframe}
      />
      {canAddMaterialOrder && (
        <HPButton
          startIcon={<Add />}
          variant="contained"
          color="primary"
          backgroundMode="medium"
          onClick={() => setSelectedMaterialOrder({id: undefined})}
          disabled={!canChangeMaterialOrders}
          {...dataTestId('create_order_button')}
        >
          {t('stock.createOrder')}
        </HPButton>
      )}
    </Stack>
  )
}
